export const WEAVING_LIST = "weaving_list";
export const WEAVING_LIST_SUCCESSFULL = "weaving_list_successfull";
export const CUTS_FROM_CUTS = "cuts_from_cuts";
export const CUTS_FROM_CUTS_SUCCESSFULL = "cust_from_cuts_successfull";
export const WEAVING_PRODUCTION_ADD = "weaving_production_add";
export const WEAVING_PRODUCTION_ADD_SUCCESSFULL = "weaving_production_add";
export const WEAVING_PRODUCTION_DELETE = "weaving_production_delete";
export const WEAVING_PRODUCTION_DELETE_SUCCESSFULL = "weaving_production_delete";